/* custom-cohorts.ts */

/* Interface(s) */
import {
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

export const deleteSegment = (
  segment: LogicalProps,
  indexPath: number[]
): LogicalProps | undefined => {
  /**
   * If indexPath is empty (length === 0), current segment is the target segment,
   * which should be deleted.
   **/
  if (indexPath.length === 0) {
    return undefined;
  }

  const [currentIndex, ...restPath] = indexPath;

  const updatedConditions = segment.conditions.map((condition, index) => {
    if (index === currentIndex) {
      if (restPath.length > 0 && "operator" in condition) {
        // recursive call of deleteSegment(...)
        return deleteSegment(condition, restPath);
      }
      return;
    }
    return condition;
  });

  const filteredConditions = updatedConditions.filter(Boolean) as (
    | BasicProps
    | LogicalProps
  )[];

  if (filteredConditions.length === 0) {
    return undefined;
  }

  return {
    ...segment,
    conditions: filteredConditions,
  };
};
